:host {
  @include richtext-host;

  --display: var(--stzh-richtext-display, block);

  --grid-template-areas: var(
    --stzh-richtext-grid-template-areas,
    "text text text text"
  );

  --grid-template-columns: var(
    --stzh-richtext-grid-template-columns,
    #{$gridColumns}
  );

  @include mq($from: small) {
    --grid-template-areas: var(
      --stzh-richtext-grid-template-areas,
      "text text text text"
    );
  }

  @include mq($from: medium) {
    --grid-template-areas: var(
      --stzh-richtext-grid-template-areas,
      "text text text text text text text text"
    );

    --grid-template-columns: var(
      --stzh-richtext-grid-template-columns,
      #{$gridColumnsMedium}
    );
  }

  ::slotted(*) {
    @include richtext-slotted;
  }

  &[has-hidden-first-margin] ::slotted(*:first-child) {
    margin-top: 0 !important;
  }

  &[has-hidden-last-margin] ::slotted(*:last-child) {
    margin-bottom: 0 !important;
  }
}

.stzh-richtext {
  @include gridGutter;
  display: var(--display);
  grid-template-areas: var(--grid-template-areas);
  grid-template-columns: var(--grid-template-columns);

  &__text {
    grid-area: text;
    display: grid;
  }
}
